import { useState } from 'react';
import { addQuery, decodeQuery, removeQuery } from 'Helpers/Query';
import history from 'State/history';
import useNotificationState from './useNotificationState';

export default function useAppState(api) {
  const [filePreviewList, setFilePreviewList] = useState([]);

  const {
    fetchNotifications,
    markNotificationRead,
    markNotificationsRead,
  } = useNotificationState(api);

  function toggleModal(modalKey) {
    const params = decodeQuery(history.location.search);
    if (params.modal && params.modal === modalKey) {
      removeQuery('modal', modalKey);
    } else {
      addQuery({ modal: modalKey });
    }
  }

  return {
    filePreviewList,
    setFilePreviewList,
    fetchNotifications,
    markNotificationRead,
    markNotificationsRead,
    toggleModal,
  };
}
